import React from 'react'
import PropTypes from 'prop-types'
import {
    Text,
    Box,
    Stack,
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PDButton from '../../components/pd-button'
import CustomDropdown from '../../components/custom-dropwdown'

export const TextOnly = ({
    textBackgroundDesktop = 'white',
    textBackgroundMobile = 'white',
    textAlignmentDesktop = 'center',
    textAlignmentMobile = 'center',

    eyebrowText,
    eyebrowFontStyle = 'italic',
    eyebrowTextDecoration = 'none',
    eyebrowColor = 'black',
    eyebrowTag = 'p',

    titleText,
    titleFontFamily = 'caslon',
    titleFontStyle = 'normal',
    titleTextDecoration = 'none',
    titleColor = 'black.100',
    titleTag = 'h2',

    bodyText,
    bodyFontStyle = 'normal',
    bodyTextDecoration = 'none',
    bodyColor = 'black.100',
    bodyTag = 'h3',

    ctaTypeMobile1 = 'button',
    ctaTypeDesktop1 = 'button',

    buttonText1,
    buttonTextColor1,
    buttonBgColor1,
    buttonLink1,

    ctaTypeMobile2 = 'button',
    ctaTypeDesktop2 = 'button',

    buttonText2,
    buttonTextColor2,
    buttonBgColor2,
    buttonLink2,

    typeId,
    name,
    ...rest
}) => {
    // rest of attibutes
    const {
        smallTitleText,
        smallTitleFontFamily,
        smallTitleFontStyle,
        smallTitleTextDecoration,
        smallTitleColor,
        smallTitleTag,

        ctaTypeMobile3,
        ctaTypeDesktop3,

        buttonText3,
        buttonTextColor3,
        buttonBgColor3,
        buttonLink3,

        ctaTypeMobile4,
        ctaTypeDesktop4,

        buttonText4,
        buttonTextColor4,
        buttonBgColor4,
        buttonLink4,

        ctaTypeMobile5,
        ctaTypeDesktop5,

        buttonText5,
        buttonTextColor5,
        buttonBgColor5,
        buttonLink5,

        ctaTypeMobile6,
        ctaTypeDesktop6,

        buttonText6,
        buttonTextColor6,
        buttonBgColor6,
        buttonLink6,

        ctaTypeMobile7,
        ctaTypeDesktop7,

        buttonText7,
        buttonTextColor7,
        buttonBgColor7,
        buttonLink7,

        ctaTypeMobile8,
        ctaTypeDesktop8,

        buttonText8,
        buttonTextColor8,
        buttonBgColor8,
        buttonLink8,

        dropdownButtonText1,
        dropdownLinkLabel1,
        dropdownLinkUrl1,
        dropdownLinkLabel2,
        dropdownLinkUrl2,
        dropdownLinkLabel3,
        dropdownLinkUrl3,
        dropdownLinkLabel4,
        dropdownLinkUrl4,
        dropdownLinkLabel5,
        dropdownLinkUrl5,
        dropdownLinkLabel6,
        dropdownLinkUrl6,
        dropdownButtonTextColor1,
        dropdownButtonBgColor1,
        dropdownType1,

        dropdownButton2Text1,
        dropdownLink2Label1,
        dropdownLink2Url1,
        dropdownLink2Label2,
        dropdownLink2Url2,
        dropdownLink2Label3,
        dropdownLink2Url3,
        dropdownLink2Label4,
        dropdownLink2Url4,
        dropdownLink2Label5,
        dropdownLink2Url5,
        dropdownLink2Label6,
        dropdownLink2Url6,
        dropdownButtonTextColor2,
        dropdownButtonBgColor2,
        dropdownType2
    } = rest
    const hasButton1 = buttonText1 && buttonLink1
    const ctaType1 = useBreakpointValue({base: ctaTypeMobile1, md: ctaTypeDesktop1})
    const ctaType2 = useBreakpointValue({base: ctaTypeMobile2, md: ctaTypeDesktop2})
    const ctaType3 = useBreakpointValue({base: ctaTypeMobile3, md: ctaTypeDesktop3})
    const ctaType4 = useBreakpointValue({base: ctaTypeMobile4, md: ctaTypeDesktop4})
    const ctaType5 = useBreakpointValue({base: ctaTypeMobile5, md: ctaTypeDesktop5})
    const ctaType6 = useBreakpointValue({base: ctaTypeMobile6, md: ctaTypeDesktop6})
    const ctaType7 = useBreakpointValue({base: ctaTypeMobile7, md: ctaTypeDesktop7})
    const ctaType8 = useBreakpointValue({base: ctaTypeMobile8, md: ctaTypeDesktop8})

    const hasButton2 = buttonText2 && buttonLink2
    const hasButton3 = buttonText3 && buttonLink3
    const hasButton4 = buttonText4 && buttonLink4
    const hasButton5 = buttonText5 && buttonLink5
    const hasButton6 = buttonText6 && buttonLink6
    const hasButton7 = buttonText7 && buttonLink7
    const hasButton8 = buttonText8 && buttonLink8

    const useButtonSpacing = (mobileType, desktopType) => {
        return {
            margin: {
                base: mobileType === 'button' || mobileType === 'buttonSmall' ? '10px 0' : 0,
                md: desktopType === 'button' || desktopType === 'buttonSmall' ? '10px 0' : 0
            }
        }
    }

    const buttonSpacing1 = useButtonSpacing(ctaTypeMobile1, ctaTypeDesktop1)
    const buttonSpacing2 = useButtonSpacing(ctaTypeMobile2, ctaTypeDesktop2)
    const buttonSpacing3or4 = useButtonSpacing(ctaTypeMobile3, ctaTypeDesktop4)
    const buttonSpacing5or6 = useButtonSpacing(ctaTypeMobile5, ctaTypeDesktop5)
    const buttonSpacing7 = useButtonSpacing(ctaTypeMobile7, ctaTypeDesktop7)
    const buttonSpacing8 = useButtonSpacing(ctaTypeMobile8, ctaTypeDesktop8)

    const dropdownLinks1 = [
        dropdownLinkLabel1 &&
            dropdownLinkUrl1 && {label: dropdownLinkLabel1, url: dropdownLinkUrl1},
        dropdownLinkLabel2 &&
            dropdownLinkUrl2 && {label: dropdownLinkLabel2, url: dropdownLinkUrl2},
        dropdownLinkLabel3 &&
            dropdownLinkUrl3 && {label: dropdownLinkLabel3, url: dropdownLinkUrl3},
        dropdownLinkLabel4 &&
            dropdownLinkUrl4 && {label: dropdownLinkLabel4, url: dropdownLinkUrl4},
        dropdownLinkLabel5 &&
            dropdownLinkUrl5 && {label: dropdownLinkLabel5, url: dropdownLinkUrl5},
        dropdownLinkLabel6 && dropdownLinkUrl6 && {label: dropdownLinkLabel6, url: dropdownLinkUrl6}
    ].filter(Boolean)

    const dropdownLinks2 = [
        dropdownLink2Label1 &&
            dropdownLink2Url1 && {
                label: dropdownLink2Label1,
                url: dropdownLink2Url1
            },
        dropdownLink2Label2 &&
            dropdownLink2Url2 && {
                label: dropdownLink2Label2,
                url: dropdownLink2Url2
            },
        dropdownLink2Label3 &&
            dropdownLink2Url3 && {
                label: dropdownLink2Label3,
                url: dropdownLink2Url3
            },
        dropdownLink2Label4 &&
            dropdownLink2Url4 && {
                label: dropdownLink2Label4,
                url: dropdownLink2Url4
            },
        dropdownLink2Label5 &&
            dropdownLink2Url5 && {
                label: dropdownLink2Label5,
                url: dropdownLink2Url5
            },
        dropdownLink2Label6 &&
            dropdownLink2Url6 && {label: dropdownLink2Label6, url: dropdownLink2Url6}
    ].filter(Boolean)

    const getTextAlignment = (alignment) => {
        if (alignment === 'left') {
            return 'flex-start'
        } else if (alignment === 'right') {
            return 'flex-end'
        } else {
            return 'center'
        }
    }

    return (
        <Box
            paddingX={{base: '15px', md: '60px'}}
            paddingTop="20px"
            paddingBottom="40px"
            backgroundColor={{
                base: textBackgroundMobile,
                md: textBackgroundDesktop
            }}
            textAlign={{base: textAlignmentMobile, md: textAlignmentDesktop}}
        >
            <Stack gap="10px" maxWidth="1400px" margin="auto">
                {eyebrowText && (
                    <Text
                        as={eyebrowTag}
                        fontFamily="inter"
                        fontWeight="300"
                        fontStyle={eyebrowFontStyle}
                        textDecoration={eyebrowTextDecoration}
                        color={eyebrowColor}
                        lineHeight="22px"
                        letterSpacing="0.07px"
                        fontSize="14px"
                    >
                        {eyebrowText}
                    </Text>
                )}

                {titleText && (
                    <Text
                        as={titleTag}
                        fontFamily={titleFontFamily}
                        fontWeight="400"
                        fontStyle={titleFontStyle}
                        fontSize={{base: '34px', lg: '42px'}}
                        textDecoration={titleTextDecoration}
                        color={titleColor}
                    >
                        {titleText}
                    </Text>
                )}

                {smallTitleText && (
                    <Text
                        as={smallTitleTag}
                        fontFamily={smallTitleFontFamily}
                        fontWeight="400"
                        fontStyle={smallTitleFontStyle}
                        fontSize={{base: '29px', lg: '34px'}}
                        textDecoration={smallTitleTextDecoration}
                        color={smallTitleColor || 'black.100'}
                    >
                        {smallTitleText}
                    </Text>
                )}

                {bodyText && (
                    <Text
                        as={bodyTag}
                        fontFamily="inter"
                        fontWeight="300"
                        fontStyle={bodyFontStyle}
                        fontSize="17px"
                        textDecoration={bodyTextDecoration}
                        color={bodyColor}
                        letterSpacing="0.085px"
                        lineHeight="26px"
                    >
                        {bodyText}
                    </Text>
                )}

                {hasButton1 || hasButton2 ? (
                    <Stack gap="10px" marginTop="5px">
                        {hasButton1 && (
                            <Box {...buttonSpacing1}>
                                <PDButton
                                    text={buttonText1}
                                    url={buttonLink1}
                                    color={buttonTextColor1}
                                    ctaType={ctaType1}
                                    buttonBackgroundColor={buttonBgColor1}
                                    buttonFontFamily="inter"
                                    hoverType="nodecor"
                                    typeId={typeId}
                                    name={name}
                                />
                            </Box>
                        )}

                        {hasButton2 && (
                            <Box {...buttonSpacing2}>
                                <PDButton
                                    text={buttonText2}
                                    url={buttonLink2}
                                    color={buttonTextColor2}
                                    ctaType={ctaType2}
                                    buttonBackgroundColor={buttonBgColor2}
                                    buttonFontFamily="inter"
                                    hoverType="nodecor"
                                    typeId={typeId}
                                    name={name}
                                />
                            </Box>
                        )}

                        {(hasButton3 || hasButton4) && (
                            <Box
                                {...buttonSpacing3or4}
                                sx={{
                                    display: 'flex',
                                    gap: '20px',
                                    justifyContent: {
                                        base: getTextAlignment(textAlignmentMobile),
                                        md: getTextAlignment(textAlignmentDesktop)
                                    }
                                }}
                            >
                                {hasButton3 && (
                                    <PDButton
                                        text={buttonText3}
                                        url={buttonLink3}
                                        color={buttonTextColor3}
                                        ctaType={ctaType3}
                                        buttonBackgroundColor={buttonBgColor3}
                                        buttonFontFamily="inter"
                                        hoverType="nodecor"
                                        typeId={typeId}
                                        name={name}
                                    />
                                )}
                                {hasButton4 && (
                                    <PDButton
                                        text={buttonText4}
                                        url={buttonLink4}
                                        color={buttonTextColor4}
                                        ctaType={ctaType4}
                                        buttonBackgroundColor={buttonBgColor4}
                                        buttonFontFamily="inter"
                                        hoverType="nodecor"
                                        typeId={typeId}
                                        name={name}
                                    />
                                )}
                            </Box>
                        )}

                        {(hasButton5 || hasButton6) && (
                            <Box
                                {...buttonSpacing5or6}
                                sx={{
                                    display: 'flex',
                                    gap: '20px',
                                    justifyContent: {
                                        base: getTextAlignment(textAlignmentMobile),
                                        md: getTextAlignment(textAlignmentDesktop)
                                    }
                                }}
                            >
                                {hasButton5 && (
                                    <PDButton
                                        text={buttonText5}
                                        url={buttonLink5}
                                        color={buttonTextColor5}
                                        ctaType={ctaType5}
                                        buttonBackgroundColor={buttonBgColor5}
                                        buttonFontFamily="inter"
                                        hoverType="nodecor"
                                        typeId={typeId}
                                        name={name}
                                    />
                                )}
                                {hasButton6 && (
                                    <PDButton
                                        text={buttonText6}
                                        url={buttonLink6}
                                        color={buttonTextColor6}
                                        ctaType={ctaType6}
                                        buttonBackgroundColor={buttonBgColor6}
                                        buttonFontFamily="inter"
                                        hoverType="nodecor"
                                        typeId={typeId}
                                        name={name}
                                    />
                                )}
                            </Box>
                        )}

                        {hasButton7 && (
                            <Box {...buttonSpacing7}>
                                <PDButton
                                    text={buttonText7}
                                    url={buttonLink7}
                                    color={buttonTextColor7}
                                    ctaType={ctaType7}
                                    buttonBackgroundColor={buttonBgColor7}
                                    buttonFontFamily="inter"
                                    hoverType="nodecor"
                                    typeId={typeId}
                                    name={name}
                                />
                            </Box>
                        )}
                        {hasButton8 && (
                            <Box {...buttonSpacing8}>
                                <PDButton
                                    text={buttonText8}
                                    url={buttonLink8}
                                    color={buttonTextColor8}
                                    ctaType={ctaType8}
                                    buttonBackgroundColor={buttonBgColor8}
                                    buttonFontFamily="inter"
                                    hoverType="nodecor"
                                    typeId={typeId}
                                    name={name}
                                />
                            </Box>
                        )}
                    </Stack>
                ) : null}

                {dropdownLinks1.length > 0 && (
                    <Box
                        marginTop="10px"
                        display="flex"
                        sx={{
                            justifyContent: {
                                base: getTextAlignment(textAlignmentMobile),
                                md: getTextAlignment(textAlignmentDesktop)
                            }
                        }}
                    >
                        <CustomDropdown
                            text={dropdownButtonText1}
                            links={dropdownLinks1}
                            fontFamily="inter"
                            buttonTextColor={dropdownButtonTextColor1}
                            buttonBgColor={dropdownButtonBgColor1}
                            type={dropdownType1}
                            variant="medium"
                            typeId={typeId}
                            name={name}
                        />
                    </Box>
                )}

                {dropdownLinks2.length > 0 && (
                    <Box
                        marginTop="10px"
                        display="flex"
                        sx={{
                            justifyContent: {
                                base: getTextAlignment(textAlignmentMobile),
                                md: getTextAlignment(textAlignmentDesktop)
                            }
                        }}
                    >
                        <CustomDropdown
                            text={dropdownButton2Text1}
                            links={dropdownLinks2}
                            fontFamily="inter"
                            buttonTextColor={dropdownButtonTextColor2}
                            buttonBgColor={dropdownButtonBgColor2}
                            type={dropdownType2}
                            variant="medium"
                            typeId={typeId}
                            name={name}
                        />
                    </Box>
                )}
            </Stack>
        </Box>
    )
}

TextOnly.propTypes = {
    textBackgroundDesktop: PropTypes.string,
    textBackgroundMobile: PropTypes.string,
    textAlignmentDesktop: PropTypes.string,
    textAlignmentMobile: PropTypes.string,

    eyebrowText: PropTypes.string,
    eyebrowFontStyle: PropTypes.string,
    eyebrowTextDecoration: PropTypes.string,
    eyebrowColor: PropTypes.string,
    eyebrowTag: PropTypes.string,

    titleText: PropTypes.string,
    titleFontFamily: PropTypes.string,
    titleFontStyle: PropTypes.string,
    titleTextDecoration: PropTypes.string,
    titleColor: PropTypes.string,
    titleTag: PropTypes.string,

    smallTitleText: PropTypes.string,
    smallTitleFontFamily: PropTypes.string,
    smallTitleFontStyle: PropTypes.string,
    smallTitleTextDecoration: PropTypes.string,
    smallTitleColor: PropTypes.string,
    smallTitleTag: PropTypes.string,

    bodyText: PropTypes.string,
    bodyFontStyle: PropTypes.string,
    bodyTextDecoration: PropTypes.string,
    bodyColor: PropTypes.string,
    bodyTag: PropTypes.string,

    ctaTypeMobile1: PropTypes.string,
    ctaTypeDesktop1: PropTypes.string,
    ctaSizeMobile1: PropTypes.string,
    ctaSizeDesktop1: PropTypes.string,

    buttonText1: PropTypes.string,
    buttonColor1: PropTypes.string,
    buttonTextColor1: PropTypes.string,
    buttonBgColor1: PropTypes.string,
    buttonLink1: PropTypes.string,

    ctaTypeMobile2: PropTypes.string,
    ctaTypeDesktop2: PropTypes.string,
    ctaSizeMobile2: PropTypes.string,
    ctaSizeDesktop2: PropTypes.string,

    buttonText2: PropTypes.string,
    buttonColor2: PropTypes.string,
    buttonTextColor2: PropTypes.string,
    buttonBgColor2: PropTypes.string,
    buttonLink2: PropTypes.string,

    ctaTypeMobile3: PropTypes.string,
    ctaTypeDesktop3: PropTypes.string,
    ctaSizeMobile3: PropTypes.string,
    ctaSizeDesktop3: PropTypes.string,

    buttonText3: PropTypes.string,
    buttonColor3: PropTypes.string,
    buttonTextColor3: PropTypes.string,
    buttonBgColor3: PropTypes.string,
    buttonLink3: PropTypes.string,

    ctaTypeMobile4: PropTypes.string,
    ctaTypeDesktop4: PropTypes.string,
    ctaSizeMobile4: PropTypes.string,
    ctaSizeDesktop4: PropTypes.string,

    buttonText4: PropTypes.string,
    buttonColor4: PropTypes.string,
    buttonTextColor4: PropTypes.string,
    buttonBgColor4: PropTypes.string,
    buttonLink4: PropTypes.string,

    ctaTypeMobile5: PropTypes.string,
    ctaTypeDesktop5: PropTypes.string,
    ctaSizeMobile5: PropTypes.string,
    ctaSizeDesktop5: PropTypes.string,

    buttonText5: PropTypes.string,
    buttonColor5: PropTypes.string,
    buttonTextColor5: PropTypes.string,
    buttonBgColor5: PropTypes.string,
    buttonLink5: PropTypes.string,

    ctaTypeMobile6: PropTypes.string,
    ctaTypeDesktop6: PropTypes.string,
    ctaSizeMobile6: PropTypes.string,
    ctaSizeDesktop6: PropTypes.string,

    buttonText6: PropTypes.string,
    buttonColor6: PropTypes.string,
    buttonTextColor6: PropTypes.string,
    buttonBgColor6: PropTypes.string,
    buttonLink6: PropTypes.string,

    ctaTypeMobile7: PropTypes.string,
    ctaTypeDesktop7: PropTypes.string,
    ctaSizeMobile7: PropTypes.string,
    ctaSizeDesktop7: PropTypes.string,

    buttonText7: PropTypes.string,
    buttonColor7: PropTypes.string,
    buttonTextColor7: PropTypes.string,
    buttonBgColor7: PropTypes.string,
    buttonLink7: PropTypes.string,

    ctaTypeMobile8: PropTypes.string,
    ctaTypeDesktop8: PropTypes.string,
    ctaSizeMobile8: PropTypes.string,
    ctaSizeDesktop8: PropTypes.string,

    buttonText8: PropTypes.string,
    buttonColor8: PropTypes.string,
    buttonTextColor8: PropTypes.string,
    buttonBgColor8: PropTypes.string,
    buttonLink8: PropTypes.string,

    dropdownButtonText1: PropTypes.string,
    dropdownLinkLabel1: PropTypes.string,
    dropdownLinkUrl1: PropTypes.string,
    dropdownLinkLabel2: PropTypes.string,
    dropdownLinkUrl2: PropTypes.string,
    dropdownLinkLabel3: PropTypes.string,
    dropdownLinkUrl3: PropTypes.string,
    dropdownLinkLabel4: PropTypes.string,
    dropdownLinkUrl4: PropTypes.string,
    dropdownLinkLabel5: PropTypes.string,
    dropdownLinkUrl5: PropTypes.string,
    dropdownLinkLabel6: PropTypes.string,
    dropdownLinkUrl6: PropTypes.string,
    dropdownButtonTextColor1: PropTypes.string,
    dropdownButtonBgColor1: PropTypes.string,
    dropdownType1: PropTypes.string,

    dropdownButton2Text1: PropTypes.string,
    dropdownLink2Label1: PropTypes.string,
    dropdownLink2Url1: PropTypes.string,
    dropdownLink2Label2: PropTypes.string,
    dropdownLink2Url2: PropTypes.string,
    dropdownLink2Label3: PropTypes.string,
    dropdownLink2Url3: PropTypes.string,
    dropdownLink2Label4: PropTypes.string,
    dropdownLink2Url4: PropTypes.string,
    dropdownLink2Label5: PropTypes.string,
    dropdownLink2Url5: PropTypes.string,
    dropdownLink2Label6: PropTypes.string,
    dropdownLink2Url6: PropTypes.string,
    dropdownButtonTextColor2: PropTypes.string,
    dropdownButtonBgColor2: PropTypes.string,
    dropdownType2: PropTypes.string,
    typeId: PropTypes.string,
    name: PropTypes.any
}

export default TextOnly
